import { FunctionComponent, useContext, useLayoutEffect, useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useParams } from 'react-router-dom';
import { ConfigContext, RightSideContext, UserContext } from '../../../context';
import { useUserByIdQuery } from '../../../services';
import { PersonalInfo } from '../PersonalInfo';
import { PostStats } from '../PostStats';
import { ReferralInvite } from '../ReferralInvite';

import classes from './ProfileRightSide.module.scss';

export const ProfileRightSide: FunctionComponent = () => {
  const { enabled: referralEnabled } = { ...useContext(ConfigContext).config.elements.referral };

  const { userProfile } = useContext(UserContext);

  const { setIsRightSideEmpty } = useContext(RightSideContext);

  const { isAnonymous } = userProfile;

  const { profileId } = useParams();

  const isOther = useMemo(() => Boolean(profileId), [profileId]);

  const { data: profileOther, isFetching: isFetchingCollaboratorProfile } = useUserByIdQuery(
    { userId: Number(profileId) },
    { skip: !isOther }
  );

  const isProfileUnavailable = isAnonymous || (isOther && !profileOther);

  useLayoutEffect(() => {
    setIsRightSideEmpty(!isFetchingCollaboratorProfile && isProfileUnavailable);
  }, [isFetchingCollaboratorProfile, isProfileUnavailable, setIsRightSideEmpty]);

  if (isFetchingCollaboratorProfile) {
    return (
      <div className={classes['profile-right-side__loader']}>
        <Skeleton width={'100%'} height={'10rem'} />
      </div>
    );
  }

  if (isProfileUnavailable) {
    return null;
  }

  return (
    <div className={classes['profile-right-side']}>
      {!isOther && referralEnabled && <ReferralInvite />}

      <PersonalInfo user={profileOther ?? userProfile} />

      {!isOther && <PostStats />}
    </div>
  );
};
